import React, { useEffect, useRef } from 'react';

const PayPalSubscription = ({ planId, onSuccess, onError }) => {
  const paypalRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // Check if PayPal SDK is loaded
    if (typeof window !== 'undefined' && window.paypal && containerRef.current) {
      // Clear any existing PayPal buttons
      containerRef.current.innerHTML = '';
      
      window.paypal.Buttons({
        style: {
          shape: 'rect',
          color: 'gold',
          layout: 'vertical',
          label: 'subscribe'
        },
        createSubscription: function(data, actions) {
          return actions.subscription.create({
            plan_id: planId
          });
        },
        onApprove: function(data, actions) {
          if (onSuccess) {
            onSuccess(data.subscriptionID);
          } else {
            alert(`订阅成功！订阅ID: ${data.subscriptionID}`);
          }
        },
        onError: function(err) {
          console.error('PayPal subscription error:', err);
          if (onError) {
            onError(err);
          } else {
            alert('订阅过程中发生错误，请重试。');
          }
        },
        onCancel: function(data) {
          console.log('PayPal subscription cancelled:', data);
        }
      }).render(containerRef.current);
    }
  }, [planId, onSuccess, onError]);

  return (
    <div 
      ref={containerRef}
      className="paypal-subscription-container"
      style={{ minHeight: '50px' }}
    />
  );
};

export default PayPalSubscription;